import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../context/LanguageContext";
import api, { formatApiError } from "../lib/api";

export const NewsletterForm = ({ compact = false }) => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success(t("newsletter.success"));
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className={compact ? "" : "card-dark p-7"}>
      {!compact && (
        <>
          <span className="badge-lime">{t("newsletter.badge")}</span>
          <h3 className="font-heading font-black text-2xl md:text-3xl text-[#0B1B3A] mt-4">{t("newsletter.title")}</h3>
          <p className="text-sm text-[#475569] mt-3 max-w-xl">{t("newsletter.subtitle")}</p>
        </>
      )}
      <div className="flex flex-col sm:flex-row gap-3 mt-5">
        <div className="relative flex-1">
          <Mail className="w-4 h-4 text-[#94A3B8] absolute left-4 top-1/2 -translate-y-1/2" />
          <input
            data-testid="newsletter-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("newsletter.placeholder")}
            className="input-flat !pl-11"
          />
        </div>
        <button data-testid="newsletter-submit-button" type="submit" disabled={busy} className="btn-blue whitespace-nowrap disabled:opacity-60">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
          {t("newsletter.cta")}
        </button>
      </div>
    </form>
  );
};

export default NewsletterForm;
